import { Button, IconEdit, Wrapper } from '@screentone/core';

import { useDataModelContext } from 'contexts/datamodel/useDataModel';

interface EditLinkedItemProps {
  uuid: string;
}

export const EditLinkedItem = ({ uuid }: EditLinkedItemProps) => {
  const { setIsEditingLinkedItem } = useDataModelContext();

  return (
    <Wrapper>
      <Button
        tertiary
        icon={IconEdit}
        iconPosition="right"
        onClick={() => setIsEditingLinkedItem((prev) => new Set(prev).add(uuid))}
      >
        Edit linked item
      </Button>
    </Wrapper>
  );
};
